import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareOnlyNonChlorineBleachIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.25 2.384a.755.755 0 0 1 1.315 0L22.72 20.381a.747.747 0 0 1-.65 1.114H1.75a.748.748 0 0 1-.653-1.116Zm.658 1.887L3.036 19.995h4.342L14.08 8.12l-2.17-3.849Zm6.09 10.795-2.78 4.929h5.562l-2.782-4.929Zm-3.058-5.42L9.101 19.995h4.394l3.642-6.456-2.197-3.893Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { productCareOnlyNonChlorineBleachIcon as default };
//# sourceMappingURL=productCareOnlyNonChlorineBleachIcon.js.map
